export default __webpack_public_path__ + "static/media/aed.d4b63307.svg";